import buildResourcePath from '@lib/buildResourcePath'

export default class Assets {

    /**
     * Adds correct URL of specified asset to the registry.
     *
     * @private
     * @param {string} name
     * @param {string} localPath
     */
    static load(name, localPath) {
        this[name] = buildResourcePath(localPath)
    }

}

Assets.load('caret', '/assets/icons/navbar-caret.png')
Assets.load('tableVisibilityIcon', '/assets/icons/toggle-visibility.png')
Assets.load('tableEditIcon', '/assets/icons/table-duplicate.svg')
Assets.load('visibleOffIcon', '/assets/icons/icon-visibility-off.svg')
Assets.load('visibleOnIcon', '/assets/icons/icon-visibility-on.svg')
Assets.load('visibleOffIconGray', '/assets/icons/icon-visibility-off-unavailable.svg')
Assets.load('visibleOnIconGray', '/assets/icons/icon-visibility-on-unavailable.svg')
Assets.load('tableRemoveIcon', '/assets/icons/table-remove.svg')
Assets.load('diagramFullscreen', '/assets/icons/diagram-fullscreen.svg')
Assets.load('arrowDown', '/assets/icons/arrow-down.svg')
Assets.load('arrowDownBlue', '/assets/icons/arrow-down-blue.svg')
Assets.load('arrowDropDownBlack24dp', '/assets/icons/arrow_drop_down_black_24dp.svg')
Assets.load('editorNavDrawer', '/assets/icons/editor-nav-drawer.svg')
Assets.load('editorNavArrowGray', '/assets/icons/editor-nav-arrow-gray.png')
Assets.load('editorNavArrowWhite', '/assets/icons/editor-nav-arrow-white.png')
Assets.load('sendMessage', '/assets/icons/fill-message.svg')
Assets.load('clock', '/assets/icons/icn-clock-12-px.svg')
Assets.load('eventHistory', '/assets/icons/icn-event-history-13-px.svg')
Assets.load('group_3', '/assets/icons/group-3.svg')
Assets.load('info', '/assets/icons/icon-info.svg')
Assets.load('warningRed', '/assets/icons/warning-red.svg')
Assets.load('warningBlue', '/assets/icons/warning-blue.svg')
Assets.load('warningOrange', '/assets/icons/warning-orange.svg')
Assets.load('warningGray', '/assets/icons/warning-gray.svg')
Assets.load('upload', '/assets/icons/upload.svg')
Assets.load('home01', '/assets/home/01.jpg')
Assets.load('home02', '/assets/home/02.jpg')
Assets.load('home03', '/assets/home/03.jpg')
Assets.load('cetethermLogoWhite', 'assets/Logo_Cetetherm-RGB-white.png');
Assets.load('linkedinLogo', 'assets/linkedin-logo.svg');
Assets.load('lockClosed', 'assets/icons/lock-closed.svg');
Assets.load('cetePhoto2', 'assets/cetetherm-photo2.jpg');